import React, { Component } from 'react'
import {Row, Col, Label, Input} from "reactstrap";
import {observer} from "mobx-react";
import ModalForm from "../../comum/components/ModalForm";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import {IconeCarregar} from "../../comum/components/Icones";
import modelo from '../../../assets/downloads/modelo_planilha_Carga_Geral.xlsx';
import CargaGeralImportarXLSStore from '../stores/CargaGeralImportarXLSStore';

@observer
export class CargaGeralImportaXLS extends Component {
    constructor(props) {
        super(props);

        this.controller = new CargaGeralImportarXLSStore(this.props.service);
        this.controllerCargaGeral = this.props.controller;
        this.mostrarErro = false;
        this.state = {
            salvado: false
        }
    };

   

    mensagemErroXLS = () => {
        if (this.controller.erroImportXLS)
            return <div className='label-obrigatorio alerta-arquivo pt-2 pb-1'>
                <Label>{this.controller.mensagemErroValidacao}</Label>
            </div>;
        else
            if (this.controller.xlsVazio)
                return <div className='label-obrigatorio alerta-arquivo pt-2'>
                    <Label>Nenhum item localizado.</Label>
                </div>;
    };

    mostrarErroPlanilhasDuplicadas = () => {
        if (this.mostrarErro)
            return <div className='label-obrigatorio alerta-arquivo pt-2 pb-1'>
                <Label>Dados duplicados nas planilhas adicionadas</Label>
            </div>;
        else
            if (this.controller.xlsVazio)
                return <div className='label-obrigatorio alerta-arquivo pt-2'>
                    <Label>Nenhum item localizado.</Label>
                </div>;
    };

    validar = () => {
        return this.controller.navioSelecionadoAgend;
    };

    handleAdicionarXLS = () => {
        this.setState({salvado: true});
        this.mostrarErro = false;
        if (this.validar() && this.controller.validarListaDadosUnicos(this.controller.listaNovas)) {
            this.controllerCargaGeral.incluirListaCargaGeral(this.controller.listaNovas, this.controller.navioSelecionadoAgend);
            this.mostrarErro = false;
        }
        else{
            this.mostrarErro = true;
        }
    };

    render() {
        const naoSalvar = this.controller.listaArquivos.length===0 ;
        return (
            <ModalForm salvando={this.controller.validandoXLS} className="area-form-modal"
                    onClickCancelar={ () => this.controllerCargaGeral.inserindoXls = false }
                    labelConfirmar='CARREGAR'
                    onClickSalvar={ this.handleAdicionarXLS }
                    esconderSalvar={ naoSalvar } >
                <h2>Importar planilha</h2>
                <Row className="pb-0">
                    <FormSelectSimples titulo="Navio *" xs={12} sm={12} md={12} lg={12} xl={12}
                                       itens={ this.controllerCargaGeral.naviosFiltrosAgend }
                                       dado={ this.controller.navioSelecionadoAgend }
                                       alerta={ !this.controller.navioSelecionadoAgend && this.state.salvado ? "Campo obrigatório" : false }
                                       onChange={ (event) => this.controller.setNavio(event) } />
                    <Col sm={12} md={12}>
                        <Label>Anexar arquivo</Label>
                        <Input type="file" onChange={e => {this.controller.guardaXLS(e);  e.target.value = null;}} accept=".xls, .xlsx"/>
                        {<Label className="mb-0"><a href={modelo} download="modelo_planilha_Carga_Geral.xlsx">Baixar modelo de planilha</a></Label>}
                        {this.mensagemErroXLS()}
                        {this.mostrarErroPlanilhasDuplicadas()}
                    </Col>
                </Row>
                { this.controller.listaArquivos
                    &&  this.controller.listaArquivos.map((nova, x) => ( <Row key={x}><Col><Label>{ nova.nomeArquivo }</Label></Col></Row> ))
                }
                { this.controller.salvando
                    && <IconeCarregar tamanho="2x" cor="#001C43" />
                }
            </ModalForm>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/CargaGeralImportaXLS.js